// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditDOB {
    width: 100%;
}

.editDOBContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.editDOBCard {
    width: 90%;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 14px;
    padding: 22px 28px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    box-sizing: border-box;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.editDOBLabel {
    color: #839696;
    font-family: "Inter", sans-serif;
    font-size: 13.5px;
    font-weight: 500;
    letter-spacing: 0.2px;
}

/* MUI DatePicker Outlined Input Overrides */
.EditDOB .MuiOutlinedInput-root {
    background-color: #142424 !important;
    border-radius: 12px !important;
    color: #FFFFFF !important;
    font-size: 15px !important;
    font-family: "Inter", sans-serif !important;
    height: 52px !important;
    padding-right: 8px !important;
    transition: all 0.2s ease !important;
}

/* Subtle border matching profile details design */
.EditDOB .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border: 1px solid #233737 !important;
    border-radius: 12px !important;
    transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
}

.EditDOB .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border: 1px solid #4DCBCA !important;
}

.EditDOB .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1.5px solid #5AAF9A !important;
}

.EditDOB .MuiOutlinedInput-root.Mui-focused {
    box-shadow: 0 0 0 3px rgba(90, 175, 154, 0.2) !important;
    outline: none !important;
}

/* Bright white date text without extra spacing */
.EditDOB .MuiInputBase-input,
.EditDOB .MuiInputBase-input input,
.EditDOB .MuiPickersSectionList-root,
.EditDOB .MuiPickersSectionList-sectionContent,
.EditDOB .MuiPickersSectionList-section,
.EditDOB input {
    color: #FFFFFF !important;
    -webkit-text-fill-color: #FFFFFF !important;
    opacity: 1 !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
}

.EditDOB .MuiInputBase-input {
    padding: 0 18px !important;
    height: 100% !important;
    font-size: 15px !important;
    font-family: "Inter", sans-serif !important;
    font-weight: 500 !important;
    outline: none !important;
    border: none !important;
}

.EditDOB .MuiInputBase-input:focus {
    outline: none !important;
}

.EditDOB .MuiInputBase-input::placeholder {
    color: #7A7A7A !important;
    -webkit-text-fill-color: #7A7A7A !important;
    opacity: 1 !important;
}

.EditDOB .MuiIconButton-root {
    color: #5AAF9A !important;
    padding: 8px !important;
}

.EditDOB .MuiIconButton-root:hover {
    color: #4DCBCA !important;
    background-color: rgba(90, 175, 154, 0.15) !important;
}

/* Popup calendar popper overrides */
.MuiPickersPopper-root .MuiPaper-root {
    background-color: #0E1B1B !important;
    color: #FFFFFF !important;
    border-radius: 16px !important;
    border: 1px solid #1E2D2D !important;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7) !important;
    padding: 12px !important;
    font-family: "Inter", sans-serif !important;
}

.MuiPickersPopper-root .MuiPickersCalendarHeader-root {
    color: #FFFFFF !important;
}

.MuiPickersPopper-root .MuiPickersCalendarHeader-label {
    color: #FFFFFF !important;
    font-weight: 600 !important;
    font-size: 15px !important;
    font-family: "Inter", sans-serif !important;
}

.MuiPickersPopper-root .MuiPickersCalendarHeader-switchViewButton,
.MuiPickersPopper-root .MuiPickersArrowSwitcher-button {
    color: #5AAF9A !important;
}

.MuiPickersPopper-root .MuiPickersCalendarHeader-switchViewButton:hover,
.MuiPickersPopper-root .MuiPickersArrowSwitcher-button:hover {
    background-color: #142424 !important;
}

.MuiPickersPopper-root .MuiDayCalendar-weekDayLabel {
    color: #839696 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    font-family: "Inter", sans-serif !important;
}

.MuiPickersPopper-root .MuiPickersDay-root {
    color: #FFFFFF !important;
    font-size: 14px !important;
    font-family: "Inter", sans-serif !important;
    border-radius: 8px !important;
    margin: 2px !important;
    transition: all 0.15s ease !important;
}

.MuiPickersPopper-root .MuiPickersDay-root:hover {
    background-color: #142424 !important;
    color: #4DCBCA !important;
}

.MuiPickersPopper-root .MuiPickersDay-root.Mui-selected {
    background-color: #5AAF9A !important;
    color: #0E1B1B !important;
    font-weight: 700 !important;
}

.MuiPickersPopper-root .MuiPickersDay-root.Mui-selected:hover {
    background-color: #4DCBCA !important;
}

.MuiPickersPopper-root .MuiPickersDay-today {
    border: 1px solid #5AAF9A !important;
}

.MuiPickersPopper-root .MuiPickersDay-root.Mui-disabled {
    color: rgba(255, 255, 255, 0.25) !important;
}

.MuiPickersPopper-root .MuiPickersYear-yearButton,
.MuiPickersPopper-root .MuiPickersMonth-monthButton {
    color: #FFFFFF !important;
    border-radius: 8px !important;
    font-family: "Inter", sans-serif !important;
}

.MuiPickersPopper-root .MuiPickersYear-yearButton:hover,
.MuiPickersPopper-root .MuiPickersMonth-monthButton:hover {
    background-color: #142424 !important;
    color: #4DCBCA !important;
}

.MuiPickersPopper-root .MuiPickersYear-yearButton.Mui-selected,
.MuiPickersPopper-root .MuiPickersMonth-monthButton.Mui-selected {
    background-color: #5AAF9A !important;
    color: #0E1B1B !important;
    font-weight: 700 !important;
}

/* Submit Button */
.editDOBSubmitBtnContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    margin-top: 10px;
}

.editDOBSubmitBtn {
    width: 100%;
    height: 48px;
    background-color: #5AAF9A;
    color: #0E1B1B;
    border: none;
    border-radius: 12px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 4px 14px rgba(90, 175, 154, 0.25);
}

.editDOBSubmitBtn:hover:not(:disabled) {
    background-color: #4DCBCA;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.35);
}

.editDOBSubmitBtn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

@media (max-width: 768px) {
    .editDOBCard,
    .editDOBSubmitBtnContainer {
        width: 95%;
        padding: 18px 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/EditDOB/EditDOB.css"],"names":[],"mappings":"AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,4CAA4C;AAC5C;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,yBAAyB;IACzB,0BAA0B;IAC1B,2CAA2C;IAC3C,uBAAuB;IACvB,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA,kDAAkD;AAClD;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,mEAAmE;AACvE;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wDAAwD;IACxD,wBAAwB;AAC5B;;AAEA,iDAAiD;AACjD;;;;;;IAMI,yBAAyB;IACzB,2CAA2C;IAC3C,qBAAqB;IACrB,iCAAiC;IACjC,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;IAC1B,2CAA2C;IAC3C,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA,oCAAoC;AACpC;IACI,oCAAoC;IACpC,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;IACpC,qDAAqD;IACrD,wBAAwB;IACxB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,2CAA2C;IAC3C,6BAA6B;IAC7B,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;IAEI,yBAAyB;IACzB,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;;IAEI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;;QAEI,UAAU;QACV,kBAAkB;IACtB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");\n\n.EditDOB {\n    width: 100%;\n}\n\n.editDOBContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n\n.editDOBCard {\n    width: 90%;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 14px;\n    padding: 22px 28px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    box-sizing: border-box;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n\n.editDOBLabel {\n    color: #839696;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13.5px;\n    font-weight: 500;\n    letter-spacing: 0.2px;\n}\n\n/* MUI DatePicker Outlined Input Overrides */\n.EditDOB .MuiOutlinedInput-root {\n    background-color: #142424 !important;\n    border-radius: 12px !important;\n    color: #FFFFFF !important;\n    font-size: 15px !important;\n    font-family: \"Inter\", sans-serif !important;\n    height: 52px !important;\n    padding-right: 8px !important;\n    transition: all 0.2s ease !important;\n}\n\n/* Subtle border matching profile details design */\n.EditDOB .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n    border: 1px solid #233737 !important;\n    border-radius: 12px !important;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease !important;\n}\n\n.EditDOB .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n    border: 1px solid #4DCBCA !important;\n}\n\n.EditDOB .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border: 1.5px solid #5AAF9A !important;\n}\n\n.EditDOB .MuiOutlinedInput-root.Mui-focused {\n    box-shadow: 0 0 0 3px rgba(90, 175, 154, 0.2) !important;\n    outline: none !important;\n}\n\n/* Bright white date text without extra spacing */\n.EditDOB .MuiInputBase-input,\n.EditDOB .MuiInputBase-input input,\n.EditDOB .MuiPickersSectionList-root,\n.EditDOB .MuiPickersSectionList-sectionContent,\n.EditDOB .MuiPickersSectionList-section,\n.EditDOB input {\n    color: #FFFFFF !important;\n    -webkit-text-fill-color: #FFFFFF !important;\n    opacity: 1 !important;\n    letter-spacing: normal !important;\n    word-spacing: normal !important;\n}\n\n.EditDOB .MuiInputBase-input {\n    padding: 0 18px !important;\n    height: 100% !important;\n    font-size: 15px !important;\n    font-family: \"Inter\", sans-serif !important;\n    font-weight: 500 !important;\n    outline: none !important;\n    border: none !important;\n}\n\n.EditDOB .MuiInputBase-input:focus {\n    outline: none !important;\n}\n\n.EditDOB .MuiInputBase-input::placeholder {\n    color: #7A7A7A !important;\n    -webkit-text-fill-color: #7A7A7A !important;\n    opacity: 1 !important;\n}\n\n.EditDOB .MuiIconButton-root {\n    color: #5AAF9A !important;\n    padding: 8px !important;\n}\n\n.EditDOB .MuiIconButton-root:hover {\n    color: #4DCBCA !important;\n    background-color: rgba(90, 175, 154, 0.15) !important;\n}\n\n/* Popup calendar popper overrides */\n.MuiPickersPopper-root .MuiPaper-root {\n    background-color: #0E1B1B !important;\n    color: #FFFFFF !important;\n    border-radius: 16px !important;\n    border: 1px solid #1E2D2D !important;\n    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7) !important;\n    padding: 12px !important;\n    font-family: \"Inter\", sans-serif !important;\n}\n\n.MuiPickersPopper-root .MuiPickersCalendarHeader-root {\n    color: #FFFFFF !important;\n}\n\n.MuiPickersPopper-root .MuiPickersCalendarHeader-label {\n    color: #FFFFFF !important;\n    font-weight: 600 !important;\n    font-size: 15px !important;\n    font-family: \"Inter\", sans-serif !important;\n}\n\n.MuiPickersPopper-root .MuiPickersCalendarHeader-switchViewButton,\n.MuiPickersPopper-root .MuiPickersArrowSwitcher-button {\n    color: #5AAF9A !important;\n}\n\n.MuiPickersPopper-root .MuiPickersCalendarHeader-switchViewButton:hover,\n.MuiPickersPopper-root .MuiPickersArrowSwitcher-button:hover {\n    background-color: #142424 !important;\n}\n\n.MuiPickersPopper-root .MuiDayCalendar-weekDayLabel {\n    color: #839696 !important;\n    font-weight: 600 !important;\n    font-size: 13px !important;\n    font-family: \"Inter\", sans-serif !important;\n}\n\n.MuiPickersPopper-root .MuiPickersDay-root {\n    color: #FFFFFF !important;\n    font-size: 14px !important;\n    font-family: \"Inter\", sans-serif !important;\n    border-radius: 8px !important;\n    margin: 2px !important;\n    transition: all 0.15s ease !important;\n}\n\n.MuiPickersPopper-root .MuiPickersDay-root:hover {\n    background-color: #142424 !important;\n    color: #4DCBCA !important;\n}\n\n.MuiPickersPopper-root .MuiPickersDay-root.Mui-selected {\n    background-color: #5AAF9A !important;\n    color: #0E1B1B !important;\n    font-weight: 700 !important;\n}\n\n.MuiPickersPopper-root .MuiPickersDay-root.Mui-selected:hover {\n    background-color: #4DCBCA !important;\n}\n\n.MuiPickersPopper-root .MuiPickersDay-today {\n    border: 1px solid #5AAF9A !important;\n}\n\n.MuiPickersPopper-root .MuiPickersDay-root.Mui-disabled {\n    color: rgba(255, 255, 255, 0.25) !important;\n}\n\n.MuiPickersPopper-root .MuiPickersYear-yearButton,\n.MuiPickersPopper-root .MuiPickersMonth-monthButton {\n    color: #FFFFFF !important;\n    border-radius: 8px !important;\n    font-family: \"Inter\", sans-serif !important;\n}\n\n.MuiPickersPopper-root .MuiPickersYear-yearButton:hover,\n.MuiPickersPopper-root .MuiPickersMonth-monthButton:hover {\n    background-color: #142424 !important;\n    color: #4DCBCA !important;\n}\n\n.MuiPickersPopper-root .MuiPickersYear-yearButton.Mui-selected,\n.MuiPickersPopper-root .MuiPickersMonth-monthButton.Mui-selected {\n    background-color: #5AAF9A !important;\n    color: #0E1B1B !important;\n    font-weight: 700 !important;\n}\n\n/* Submit Button */\n.editDOBSubmitBtnContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    margin-top: 10px;\n}\n\n.editDOBSubmitBtn {\n    width: 100%;\n    height: 48px;\n    background-color: #5AAF9A;\n    color: #0E1B1B;\n    border: none;\n    border-radius: 12px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    box-shadow: 0 4px 14px rgba(90, 175, 154, 0.25);\n}\n\n.editDOBSubmitBtn:hover:not(:disabled) {\n    background-color: #4DCBCA;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.35);\n}\n\n.editDOBSubmitBtn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n    .editDOBCard,\n    .editDOBSubmitBtnContainer {\n        width: 95%;\n        padding: 18px 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
